import { useEffect, useRef, useState } from 'react';
import T from '../i18n/content.js';
import { useT } from '../i18n/LangContext.jsx';

const SEAL_IMAGES = [
  { src: '/imgs/pen.png',      alt: 'Fountain pen' },
  { src: '/imgs/envelope.png', alt: 'Sealed correspondence' },
];

export default function Hero({ variant = 'slate' }) {
  const t = useT();
  const H = T.hero;
  const bone = variant === 'bone';

  const [active, setActive] = useState(0);
  const pausedRef = useRef(false);

  useEffect(() => {
    const id = setInterval(() => {
      if (!pausedRef.current) {
        setActive(i => (i + 1) % SEAL_IMAGES.length);
      }
    }, 6000);
    return () => clearInterval(id);
  }, []);

  return (
    <section className={`hero ${bone ? 'hero--bone' : ''}`}>
      <div className="hero__grid">
        <div className="hero__copy">
          <h1 className="hero__lockup">
            <span className="row">
              {t(H.l1pre)}
              {t(H.l1em) && <em>{t(H.l1em)}</em>}
              {t(H.l1post)}
            </span>
            <span className="row">
              {t(H.l2pre)}
              {t(H.l2em) && <em>{t(H.l2em)}</em>}
              {t(H.l2post)}
            </span>
          </h1>
          {/* In the copy flow (after the headline) so on mobile the statement
              wraps around it (float); on desktop it sits in the right grid area. */}
          <div className="hero__mark">
            <div
              className="hero__seal"
              onMouseEnter={() => { pausedRef.current = true; }}
              onMouseLeave={() => { pausedRef.current = false; }}
            >
              {SEAL_IMAGES.map((img, i) => (
                <img
                  key={img.src}
                  src={img.src}
                  alt={img.alt}
                  className={`hero__seal-img ${i === active ? 'is-active' : ''}`}
                />
              ))}
              <div className="hero__seal-dots" role="tablist" aria-label="Hero imagery">
                {SEAL_IMAGES.map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    role="tab"
                    aria-selected={i === active}
                    aria-label={`Show image ${i + 1}`}
                    className={`hero__seal-dot ${i === active ? 'is-active' : ''}`}
                    onClick={() => setActive(i)}
                  />
                ))}
              </div>
            </div>
          </div>
          <p className="hero__statement">{t(H.statement)}</p>
          <div className="hero__cn-block">
            <span className="hero__cn">{t(H.cnLine)}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
